var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.8,
    height: 10.762,
    viewBox: "0 0 18.8 10.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(-0.943 -0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M19.663-.4a.416.416,0,0,0,0-.491C19.619-.952,19.619-.339,19.663-.4ZM9.872,4.735a10.5,10.5,0,0,1-6.4-2.788A19.227,19.227,0,0,1,.943-.646c.866-1.083,4.578-5.381,8.929-5.381a10.5,10.5,0,0,1,6.4,2.788A19.25,19.25,0,0,1,18.8-.646C17.934.437,14.223,4.736,9.872,4.736Zm0,0",
    transform: "translate(0 6.859)",
    fill: "#686c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M167.164,46.07a4.45,4.45,0,1,0,4.45,4.45A4.45,4.45,0,0,0,167.164,46.07Zm0,8.067a3.617,3.617,0,1,1,3.617-3.617,3.617,3.617,0,0,1-3.617,3.617Zm0,0",
    transform: "translate(-157.293 -44.307)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGrey);
export default __webpack_public_path__ + "static/media/EyeGrey.bbf6a75a7d4011d5ec0b1d0ec4ab7132.svg";
export { ForwardRef as ReactComponent };